import { Card, Col, Row, TabContent, TabPane } from "reactstrap";
import ExpTabsContentTabel from "./ExpTabsContentTabel";
import { useSelector,} from "react-redux";


const captionHeadTab3 = [
  { label: "Sr.", key: "sr" },
  // { label: "Outlet Type", key: "outletType" },
  { label: "Visiting Breakups", key: "visitingBreakups" },
  { label: "Agend Type", key: "Agendname" },
];

const captionHeadTab4 = [
  { label: "Sr.", key: "sr" },
  { label: "User", key: "user" },
  { label: "Date", key: "date" },
  { label: "Status", key: "status" },
  { label: "Remark", key: "remark" },
];



export interface TabContentProp {
  basicTab: string;
  tabData?: any;
  FwData?: any;
  NCAData?: any;
  expenseLog?: any;
}


const ExpVerticalTabContent: React.FC<TabContentProp> = ({
  basicTab,
  tabData,
  FwData,
  NCAData,
  expenseLog,
}) => {


const captionHeadTab2 = [
  { label: "Sr.", key: "sr" },
  { label: "Visited Towns", key: "visitedTown" },
  { label: "Visiting Breakups", key: "visitingBreakups" }, 
  { label: "Outlet type Name", key: "OutlettypeName" },

];



   
  const auditScreenStatus_validation = useSelector((state:any)=> state.audit.auditScreenStatus)
  // console.log('auditScreenStatus_validation',FwData);
  const captionHead = [
  { id: 1, label: "Expense Head", key: "expenseHead" },
  { id: 3, label: "Requested Amount", key: "requested" },
  { id: 4, label: "Approved by Manager", key: "approvebyManager" },
  // { id: 5, label: "Audited", key: "audited" },

  ...(auditScreenStatus_validation ? [{id: 5, label: "Audited", key: "audited"}]:[]),
  { id: 6, label: "Attachment", key: "attachment" },
  { id: 7, label: "Final Amount", key: "final" },
];



  const formateTownData = (data: any) => {
    return (
      data.map((item: any, index: any) => ({
        sr: index + 1,
        visitedTown: item.Stownname,
        visitingBreakups: item.TotalTowen,
        OutlettypeName:item.OutlettypeName,
        Agendname:item.Agendname
      })) || []
    );
  };
  
  // console.log('formateTownData',formateTownData);
  const townData = basicTab === "2"
      ? formateTownData(FwData?.towenBydata || [])
      : basicTab === "3"
      ? formateTownData(NCAData?.towenBydata || [])
      : [];

  const formateOutletData = (data: any) => {
    return (
      data.map((item: any, index: any) => ({
        sr: index + 1,
        outletType: item.OutlettypeName,
        visitingBreakups: item.TotalOutlet,
      })) || []
    );
  };
  const outletData =
    basicTab === "2"
      ? formateOutletData(FwData?.OutletTypeBydata || [])
      : basicTab === "3"
      ? formateOutletData(NCAData?.OutletTypeBydata || [])
      : [];


  return (
    <Col md="8" xs="12">
      <TabContent activeTab={basicTab}>

        <TabPane tabId="1">
          
          <Row className="text-center mt-2">
            <ExpTabsContentTabel
              data={
                Array.isArray(tabData)
                  ? tabData?.map((item: any) => ({
                      id: item.Expid,
                      expenseHead: item.ExpenseHead,
                      // requested: item.ExpReqAmount, 
                      requested: item.ExpIlAmount, 
                      approvebyManager: item.ExpAprAmount,
                      audited: item.ExpAuditAmount,
                      description: item.ExpNote,
                      
                      // attachment: ImagesAssets.CardImages, // or item.attachment if available   API Image...
                      attachment:item.Image == null? 'No attachment' :item.Image, // or item.attachment if available   API Image...

                      final: item.ExpFinalAmount,
                      expenseRemark:item.ExpAuditRemark,
                      ExpListId:item.ExpListId

                    }))
                  : []
              }
              columns={captionHead}
            />
          </Row>

        </TabPane>

        <TabPane tabId="2">
          <Row>
            <Col md="12" sm="12">
              <ExpTabsContentTabel
                data={townData && townData.length > 0 ? townData : []} // Ensure data is present
                columns={captionHeadTab2}
              />
            </Col>
          </Row>
        </TabPane>

        <TabPane tabId="3">
          <Row>
        <Col md="12" sm="12">
              <ExpTabsContentTabel
                data={townData && townData.length > 0 ? townData : []} // Ensure data is present
                // columns={captionHeadTab2}
                columns={captionHeadTab3}
              />
            </Col>
            </Row>
        </TabPane>

        <TabPane tabId="4">
          <Col sm="12">
            <Card>
              <Row className="card-block">
                <ExpTabsContentTabel
                  data={Array.isArray(expenseLog?.wfLogs)
                    ? expenseLog?.wfLogs?.map((item: any,index:any) => ({
                        sr: index+1,
                        user: `${item?.Employee.FirstName}`+' '+`${ item?.Employee?.LastName}`,
                        date: item?.CreatedAt.split(" ")[0],
                        status: item?.WfTitle,
                        remark: item?.WfNote,
                      }))
                    : []}
                  columns={captionHeadTab4}
                />
              </Row>
            </Card>
          </Col>
        </TabPane>
      </TabContent>
    </Col>
  );
};

export default ExpVerticalTabContent;
